var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.479 3.70328C7.85564 3.70328 2.5 8.93549 2.5 15.3724C2.5 18.6269 3.86888 21.5733 6.0784 23.6913C7.70006 21.3085 11.0746 19.7522 14.861 19.7522C18.4089 19.7522 21.5949 21.1184 23.3164 23.2505C25.2683 21.1734 26.4583 18.4068 26.4583 15.3724C26.4583 8.93549 21.1027 3.70328 14.479 3.70328ZM23.8388 24.4918C26.229 22.1582 27.7083 18.9355 27.7083 15.3724C27.7083 8.2385 21.7776 2.46875 14.479 2.46875C7.18074 2.46875 1.25 8.23851 1.25 15.3724C1.25 22.5066 7.18073 28.2764 14.479 28.2764C17.9538 28.2764 21.1185 26.9686 23.4808 24.8285C23.518 24.8148 23.5544 24.7975 23.5895 24.7763C23.705 24.7067 23.7896 24.606 23.8388 24.4918ZM22.4137 24.1151C21.008 22.2994 18.1973 20.9867 14.861 20.9867C11.2869 20.9867 8.31569 22.4936 7.02929 24.5114C9.07334 26.095 11.6615 27.0418 14.479 27.0418C17.5244 27.0418 20.3017 25.9358 22.4137 24.1151ZM14.6429 7.40688C12.9934 7.40688 11.6667 8.71293 11.6667 10.3103V12.3222C11.6667 13.9198 12.9934 15.2256 14.6429 15.2256C16.2927 15.2256 17.6191 13.9198 17.6191 12.3222V10.3103C17.6191 8.7129 16.2926 7.40688 14.6429 7.40688ZM10.4167 10.3103C10.4167 8.01934 12.3151 6.17235 14.6429 6.17235C16.9711 6.17235 18.8691 8.01937 18.8691 10.3103V12.3222C18.8691 14.6134 16.971 16.4601 14.6429 16.4601C12.3151 16.4601 10.4167 14.6134 10.4167 12.3222V10.3103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5b3bef8949c2bbce6de5585319b1f189.svg";
export { ForwardRef as ReactComponent };